module.exports = "<div class=\"b3-p-overlay\"></div>\n<apm-menu-layout></apm-menu-layout>"